import { ThemeAPI } from 'nuvo-react'

export const reviewEntries: ThemeAPI['reviewEntries'] = {
  duplicateButton: {
    display: 'none !important',
  },
}
